/**
 * Helpers to work with images returned by /api/content.
 *
 * Each image: { id, placement, category, caption, alt, order, url }
 * `url` is a relative path starting with /api/uploads — we prefix with REACT_APP_BACKEND_URL.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function fullImageUrl(image) {
  if (!image) return null;
  const u = image.url || "";
  if (!u) return null;
  if (/^https?:\/\//i.test(u)) return u;
  return `${BACKEND_URL}${u}`;
}

export function imagesByPlacement(images = []) {
  const out = { hero: [], intro: [], mussoorie: [], experience: [], food: [], gallery: [] };
  for (const img of images) {
    if (out[img.placement]) out[img.placement].push(img);
  }
  for (const key of Object.keys(out)) {
    out[key].sort((a, b) => (a.order || 0) - (b.order || 0));
  }
  return out;
}
